<template lang="pug">
    include /@ibkr/lib.common/src/icon/basic

    ib-col(class="flex")
        ib-row
            ib-col(class="mf-head fixed-flex middle inset-16")
                h2(
                 :class="{ fs2: $media.l, fs4: !$media.l}",
                 v-text="$router && $router.options.isPortal ? $t('mutual_fund_scanner') : $t('mutual_fund_search_tool')"
                )
                div(v-if="resultsview", class="text-end center")
                    ib-button(class="mf-edit" tone="accent", appearance="clear", @click="refresh")
                        +icon-basic-restart
                        |  {{ $t('refresh_results') }}
                    ib-button(class="mf-edit" tone="accent", @click="startOver") {{ $t('start_over') }}
                    ib-button(class="mf-edit" tone="accent", @click="showForm") {{ $t('edit') }}
                    ib-button(class="mf-edit" tone="accent", @click="downloadData", :busy="downloading") {{ $t('download_xls') }}
                    ib-button(
                        class="mf-edit",
                        v-if="signedIn && ($router && !$router.options.isPortal) && typeof amSession === 'undefined'",
                        tone="accent",
                        @click="logOut"
                    ) {{ $t('log_out') }}
        ib-row
            ib-col(
                v-if="resultsview", 
                class="fs7 insetx-16 after-8",
                :class="{ 'insetx-24': !$media.l }"
            )
                span(v-if="fields.identifier") {{$t('isin')}}, {{$t('cusip')}}, {{$t('or')}} {{$t('ticker_symbol')}}:
                span(v-if="fields.identifier", class="fg-accent outsetx-8 filter-labels", v-text="fields.identifier.toUpperCase()")
                br(v-if="!$media.l && fields.identifier")
                span {{$t('investor_residency')}}:
                span(class="fg-accent outsetx-8 filter-labels", v-text="fields.residence")
                br(v-if="!$media.l")
                span {{$t('fund_family')}}:
                span(class="fg-accent outsetx-8 filter-labels", v-text="fields.fundFamily")
                br(v-if="!$media.l")
                span {{$t('commission_charged')}}:
                span(class="fg-accent outsetx-8 filter-labels", v-text="fields.transLabel")
                br(v-if="!$media.l")
                span {{$t('fund_type')}}:
                span(class="fg-accent outsetx-8", v-text="fields.fundType")
        ScanFilters(v-show="!resultsview", @onSubmit="onSubmit", ref="scanFilters")
        SearchResults(
            v-if="resultsview",
            @signedIn="checkSignedIn",
            :scanFields="filters",
            ref="searchResults"
        )
        ib-row 
            ib-col
                div(class="insetx-16 border-top")
                    p(class="fs8 outsety-8") Source: Refinitiv
                    P(class="fs8") The information presented is taken from, or based upon, information obtained from publicly available sources, the completeness and accuracy of which has not been independently verified, and cannot be assured by Interactive Brokers.
                    p(class="fs8") Not all products will be available to all investors due to a number of factors including account type requirements and regional restrictions.
</template>

<script>
    import api from '../api/'
    import ScanFilters from './ScanFilters.vue'
    import SearchResults from './SearchResults.vue'
    import { countries } from '../js/countries'

    export default {
        name: 'MFScanner',

        components: {
            ScanFilters,
            SearchResults
        },

        data() {
            return {
                amSession: window.AM_SESSION_ID,
                fields: '',
                filters: '',
                order: [
                    {"NAME": "FUND NAME"},
                    {"SYMBOL": "SYMBOL"},
                    {"FAMILY": "FUND FAMILY"},
                    {"INVEST_TYPE": "FUND TYPE"},
                    {"EXPENSE_RATIO": "EXPENSE RATIO %"},
                    {"TXN": "TRANSACTION FEE"},
                    {"LT": "LOAD TYPE"},
                    {"MGTFEE": "MANAGEMENT FEES"},
                    {"EXPENSE_RATIO": "EXPENSE RATIO %"},
                    {"PERF": "PERFORMANCE - YTD"},
                    {"LIPPER": "LIPPER RATING"},
                    {"SHARPE": "SHARPE RATIO"},
                    {"FUND_GEO": "GEOGRAPHICAL FOCUS"},
                    {"ESG": "ESG SCORE"},
                    {"ASSETS": "ASSETS UNDER MANAGEMENT"},
                    {"ISIN": "ISIN"},
                    {"CUSIP": "CUSIP"},
                    {"SHARE_CLASS": "SHARE CLASS"},
                    {"INITIAL_INVEST": "INITIAL INVESTMENT MINIMUM"}   
                ],
                resultsview: false,
                total: '',
                responses: [],
                signedIn: false,
                downloading: false,
                countries: countries(this),
                checkBoolean: [
                    { label: this.$t('yes'), value: 'T' },
                    { label: this.$t('no'), value: 'F' },
                    { label: this.$t('all'), value: 'All' }
                ],
            }
        },

        created() {
            this.getTotalFunds();
            const params = this.$route.query;
            if (params.identifier || params.residency || params.family || params.txnfee ||  params.itype) {
                const identifier = params.identifier || '';
                const residency =  params.residency || 'USA'
                const family = params.family || 'All';
                const txnfee = params.txnfee || 'All';
                const type = params.itype || 'All';
                const page = params.page || 1;
                const curCountry = this.countries.find(country => country.value === residency);
                const curFee = this.checkBoolean.find(fee => fee.value === txnfee);

                const filters = {
                    identifier: identifier,
                    residency: residency,
                    family: family,
                    txnfee: txnfee,
                    itype: type,
                    page: parseInt(page)
                };
                const fundFields = {
                    identifier: identifier,
                    residence: curCountry.label,
                    fundFamily: family,
                    transLabel: curFee ? curFee.label : this.$t('all'),
                    fundType: type
                };
                this.$store.dispatch('fundscanner/setFiltersFromUrl', filters);
                this.onSubmit(fundFields, filters)
            }
        },

        methods: {
            checkSignedIn(signedIn) {
                this.signedIn = signedIn;
            },
            changeOrder(row) {
                let newOrder = {};
                for (let i = 0; i < this.order.length; i++) {
                    let key = Object.keys(this.order[i]);
                    if (row.hasOwnProperty(key)) {
                        newOrder[key] = row[key];
                    }
                }
                return newOrder;
            },
            downloadData() {
                // expense ratio % is in different locations when looking at the table vs downloading table
                this.downloading = true;
                this.filters.page = ''; // Return all results
                api.searchFunds(this.filters)
                    .then(r => {
                        this.responses = r.data;
                        if (this.responses.total === 0) {
                            this.$alert(this.$t('zero_results'));
                            this.downloading = false;
                            return;
                        }
                        return this.responses;   
                    })
                    .then(responses => {
                        const filename = `/${this.responses.csv}`;
                        fetch(filename)
                            .then(res => {
                                return res.text();
                            })
                            .then(r => {
                                const fileContents = r;
                                const lines = fileContents.split("\n");
                                for (let i = 0; i < lines.length; i++) {
                                    const fileRow = lines[i].split(',');
                                    const updatedRow = fileRow.map(field => { 
                                        if (field == '""') {
                                            field = 'N/A';
                                        }
                                        return field;
                                    });
                                    lines[i] = updatedRow.join(',');
                                }

                                const modifiedFileContents = lines.join('\n');
                                const blob = new Blob([modifiedFileContents], {type: 'text/csv'});
                                const blobUrl = URL.createObjectURL(blob);

                                const link = document.createElement('a');
                                link.download = 'IBKR_Mutual_Fund_Scanner_Results';
                                link.href = blobUrl;
                                link.click();
                                this.downloading = false;
                                URL.revokeObjectURL(blob);
                            })
                            .catch(error => console.error(error))
                    })
                    .catch((error) => {
                        console.error(error);
                    })
            },
            getTotalFunds() {
                api.getTotalFunds()
                   .then(res => this.total = res.total)
            },
            logOut() {
                api.logOut()
                    .then(() => {
                        window.location.reload();
                    })
                    .catch((error) => {
                        console.log(error);
                        console.log("cookie", document.cookie);
                    })
            },
            onSubmit(fundFields, filters) {
                this.fields = fundFields;
                this.filters = filters;
                this.resultsview = true;
            },
            showForm() {
                this.resultsview = false;
                this.$router.replace({ query: {} });
            },
            startOver() {
                this.showForm();
                this.$refs.scanFilters.resetFilters();
            },
            refresh() {
                this.$refs.searchResults.refresh();
            }
        },

        watch: {
            resultsview: {
                handler: function(val) {
                    window.scrollTo(0,0);
                }
            }
        },
    }
</script>

<style lang="less">
    .mf-head {
        flex-wrap: wrap;
    }

@media (max-width: 850px) {
    .flex-fixed {
        &.sm-no-flex {
            display: block;
            .mobile-descr {
                margin-bottom: 1em;
            }
        }
    }
    .text-end {
        &.center {
            text-align: center;
            margin-top: 1rem;
        }
    }
    .mf-head {
        h2 {
            width: 100%;
            text-align: center;
        }
    }
}

@media (max-width: 600px) {
    .mf-edit {
        width: 47%;
        padding: 7px;
    }
    .filter-labels {
        margin-bottom:8px;
        display: inline-block;
    }
}
</style>